var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTaganowLogoColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 27,
    viewBox: "0 0 122 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.99878V9.34741H5.96471V20.999C7.90843 20.3373 9.91039 19.713 11.9654 19.1276V9.34741H17.9216V3.99878H0Z",
    fill: "url(#paint0_linear_1448_2574)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7194 15.0005C63.6985 18.4183 62.5122 21.2695 60.1621 23.5486C57.7789 25.8496 54.7903 27 51.1998 27C47.7331 27 44.7917 25.8646 42.3771 23.5921C40.3323 21.6601 39.1494 19.3609 38.8285 16.6943C40.7807 16.4192 42.7591 16.1744 44.7655 15.9648C44.9034 17.5211 45.4651 18.8443 46.4473 19.9328C47.6547 21.2711 49.2284 21.9419 51.1684 21.9419C52.5206 21.9419 53.686 21.6484 54.6665 21.0631C55.7202 20.4291 56.4216 19.5102 56.7723 18.3112H52.8014V15.3074C55.7377 15.1363 58.7193 15.034 61.7393 15.0071C62.4005 15.0005 63.0617 14.9988 63.7194 15.0005Z",
    fill: "url(#paint1_linear_1448_2574)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7244 11.3435H56.1026C54.9828 9.30985 53.2835 8.29213 51.0045 8.29213C49.1539 8.29213 47.6283 8.96769 46.4278 10.3153C45.6022 11.247 45.069 12.3331 44.8334 13.5702C42.8107 13.6772 40.8069 13.8211 38.829 14.0001C39.068 11.0137 40.2686 8.48339 42.4289 6.40935C44.8093 4.13528 47.7194 3 51.1577 3C53.7221 3 56.0973 3.76153 58.2834 5.28811C60.552 6.86557 62.0329 8.88346 62.7244 11.3435Z",
    fill: "url(#paint2_linear_1448_2574)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8256 26.0012H33.2055L32.0391 22.8251H23.7477L22.4865 26.0012H15.9302L18.0978 21.0301C21.4457 20.0335 24.947 19.1459 28.5809 18.3738L30.3143 18.0157C32.1545 17.6461 34.0292 17.3079 35.9331 17.0011L39.8256 26.0012Z",
    fill: "url(#paint3_linear_1448_2574)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8481 14.6095C32.9911 14.8161 31.1583 15.0532 29.35 15.3191L27.9676 11.023H27.872L26.3384 15.7898C24.1562 16.1522 22.014 16.5552 19.9135 16.9989L25.4864 3.99878H30.3376L34.8481 14.6095Z",
    fill: "url(#paint4_linear_1448_2574)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.9117 26.3339H79.4089L78.2631 23.0614H70.1186L68.8813 26.3339H62.4395L67.1989 14.8845C68.8492 14.9236 70.4859 14.9883 72.1074 15.0766L72.1445 14.9457C72.1547 14.9101 72.1412 14.8726 72.1124 14.8489L71.2238 14.1604C70.039 14.0345 68.8441 13.9206 67.6407 13.8204L71.8534 3.68509H76.5756L85.9117 26.3339ZM76.4897 14.9456C76.4795 14.9099 76.4914 14.8725 76.5201 14.8487L76.5539 14.8215H76.5556L79.2925 12.7034C79.3602 12.6507 79.3247 12.5435 79.2383 12.5402L75.7111 12.4041C75.6738 12.4025 75.64 12.3786 75.6282 12.3447L74.4045 9.09597C74.374 9.01607 74.2589 9.01607 74.2301 9.09597L73.0064 12.3447C72.9929 12.3786 72.9607 12.4025 72.9234 12.4041L69.3962 12.5402C69.3099 12.5435 69.2743 12.6507 69.342 12.7034L71.2238 14.1604L72.1124 14.8489C72.1412 14.8726 72.1547 14.9101 72.1445 14.9457L72.1074 15.0766L71.1886 18.2793C71.1649 18.3609 71.258 18.4255 71.3291 18.3795L71.9097 18.0004V17.9987L74.2656 16.4569C74.2961 16.4365 74.3368 16.4365 74.3689 16.4569L77.3038 18.3795C77.3765 18.4255 77.4696 18.3609 77.4459 18.2793L76.4897 14.9456Z",
    fill: "url(#paint5_linear_1448_2574)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M90.924 14V4.2H94.438L96.384 12.74H96.636V4.2H98.456V14H94.942L92.996 5.46H92.744V14H90.924Z",
    fill: "url(#paint6_linear_1448_2574)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M104.111 14.196C102.879 14.196 101.899 13.86 101.171 13.188C100.443 12.5067 100.079 11.536 100.079 10.276V7.924C100.079 6.664 100.443 5.698 101.171 5.026C101.899 4.34466 102.879 4.004 104.111 4.004C105.343 4.004 106.323 4.34466 107.051 5.026C107.779 5.698 108.143 6.664 108.143 7.924V10.276C108.143 11.536 107.779 12.5067 107.051 13.188C106.323 13.86 105.343 14.196 104.111 14.196ZM104.111 12.544C104.802 12.544 105.338 12.3433 105.721 11.942C106.104 11.5407 106.295 11.004 106.295 10.332V7.868C106.295 7.196 106.104 6.65933 105.721 6.258C105.338 5.85666 104.802 5.656 104.111 5.656C103.43 5.656 102.893 5.85666 102.501 6.258C102.118 6.65933 101.927 7.196 101.927 7.868V10.332C101.927 11.004 102.118 11.5407 102.501 11.942C102.893 12.3433 103.43 12.544 104.111 12.544Z",
    fill: "url(#paint7_linear_1448_2574)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M110.466 14L109.178 4.2H111.012L111.964 12.712H112.216L113.448 4.2H116.64L117.872 12.712H118.124L119.076 4.2H120.91L119.622 14H116.43L115.17 5.292H114.918L113.658 14H110.466Z",
    fill: "url(#paint8_linear_1448_2574)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1448_2574",
    x1: 0.00000120478,
    y1: 2.99989,
    x2: 84.8386,
    y2: 30.3317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0051F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1448_2574",
    x1: 0.0000600971,
    y1: 2.99994,
    x2: 84.8386,
    y2: 30.3317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0051F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1448_2574",
    x1: 0.000191913,
    y1: 2.99967,
    x2: 84.8388,
    y2: 30.3315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0051F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1448_2574",
    x1: -0.000121514,
    y1: 2.99971,
    x2: 84.8384,
    y2: 30.3316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0051F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1448_2574",
    x1: 0.000104152,
    y1: 2.99989,
    x2: 84.8387,
    y2: 30.3317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0051F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1448_2574",
    x1: -0.0000855622,
    y1: 2.99872,
    x2: 84.8385,
    y2: 30.3306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0051F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1448_2574",
    x1: 67.0516,
    y1: 9.1,
    x2: 120.91,
    y2: 9.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FCD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0158EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1448_2574",
    x1: 67.0516,
    y1: 9.1,
    x2: 120.91,
    y2: 9.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FCD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0158EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1448_2574",
    x1: 67.0516,
    y1: 9.1,
    x2: 120.91,
    y2: 9.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FCD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0158EF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaganowLogoColor);
export default __webpack_public_path__ + "static/media/taganow-logo-color.f94c486523c024daaa9c1fd712799ec4.svg";
export { ForwardRef as ReactComponent };